var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgP2Alerts = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 358,
    height: 140,
    viewBox: "0 0 358 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5911_31277",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 358,
    height: 140
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(42px)",
      clipPath: "url(#bgblur_0_5911_31277_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 84,
    d: "M0 5C0 2.23857 2.23858 0 5 0H353C355.761 0 358 2.23858 358 5V135C358 137.761 355.761 140 353 140H5.00001C2.23858 140 0 137.761 0 135V5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5911_31277)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M363.289 21.3744C366.773 20.8115 370.191 22.7021 371.565 25.9525L405.658 106.584C406.933 109.6 406.15 113.092 403.71 115.275L334.97 176.772C332.977 178.555 330.198 179.169 327.639 178.392L260.62 158.046C257.843 157.203 255.781 154.863 255.294 152.002L245.251 92.9807C244.912 90.9859 245.375 88.9379 246.541 87.2839L282.101 36.8269C283.288 35.142 285.104 34.0069 287.139 33.6781L363.289 21.3744Z",
    fill: "#E2BEE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.986 23.7958C326.368 22.5248 329.242 22.6012 331.553 23.9969L389.623 59.0767C392.17 60.6156 393.595 63.4908 393.278 66.4499L385.712 136.906C385.562 138.304 385.029 139.635 384.173 140.751L333.642 206.595C330.658 210.483 324.841 210.607 321.694 206.849L268.22 142.985C267.247 141.823 266.64 140.398 266.477 138.891L258.411 64.2346C258.075 61.127 259.662 58.1271 262.419 56.6553L323.986 23.7958Z",
    stroke: "#CF98D9",
    strokeWidth: 3.65044,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5911_31277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314 120C327.255 120 338 109.255 338 96C338 82.7452 327.255 72 314 72C300.745 72 290 82.7452 290 96C290 109.255 300.745 120 314 120Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M313.544 93.2471C312.091 93.2471 310.914 94.4521 310.914 95.9377V107.388C310.914 108.875 312.092 110.079 313.544 110.079C314.997 110.079 316.174 108.874 316.174 107.388V95.9377C316.174 94.4521 314.996 93.2471 313.544 93.2471Z",
    fill: "#9C44C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.544 91.1438C314.997 91.1438 316.174 89.9659 316.174 88.5138C316.174 87.0608 314.996 85.8838 313.544 85.8838C312.092 85.8838 310.914 87.0617 310.914 88.5138C310.913 89.9659 312.091 91.1438 313.544 91.1438Z",
    fill: "#9C44C0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_5911_31277_clip_path",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 5C0 2.23857 2.23858 0 5 0H353C355.761 0 358 2.23858 358 5V135C358 137.761 355.761 140 353 140H5.00001C2.23858 140 0 137.761 0 135V5Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5911_31277",
    x: 278,
    y: 69.6,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.584314 0 0 0 0 0.615686 0 0 0 0 0.647059 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5911_31277"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5911_31277",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgP2Alerts);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/P2alerts.da31ed593a21c7e249e93a75b2fa0a97.svg";